import { message } from 'antd';

type FileType = 'application/pdf' | 'image/jpeg' | 'image/png' | 'image/jpg';

interface FileTypeConfig {
  mimeTypes: FileType[];
  maxSize: number;
  errorMessage: string;
}

// File type configurations
export const FILE_TYPE_CONFIG: Record<string, FileTypeConfig> = {
  PDF: {
    mimeTypes: ['application/pdf'],
    maxSize: 100 * 1024 * 1024, // 100MB
    errorMessage: 'PDF file size cannot exceed 100MB!',
  },
  IMAGE: {
    mimeTypes: ['image/jpeg', 'image/png', 'image/jpg'],
    maxSize: 15 * 1024 * 1024, // 15MB
    errorMessage: 'Image file size cannot exceed 15MB!',
  },
};

// Allowed file types for validation
export const ALLOWED_FILE_TYPES: FileType[] = [
  ...FILE_TYPE_CONFIG.PDF.mimeTypes,
  ...FILE_TYPE_CONFIG.IMAGE.mimeTypes,
];

// File validation function
export const validateFile = (file: File): boolean => {
  // Check if file type is allowed
  if (!ALLOWED_FILE_TYPES.includes(file.type as FileType)) {
    message.error('Only PDF, JPG, or PNG files can be uploaded!');
    return false;
  }

  // Check file size based on file type
  const fileConfig = Object.values(FILE_TYPE_CONFIG).find((config) =>
    config.mimeTypes.includes(file.type as FileType),
  );

  if (!fileConfig) {
    message.error('Unsupported file type!');
    return false;
  }

  if (file.size > fileConfig.maxSize) {
    message.error(fileConfig.errorMessage);
    return false;
  }

  return true;
};
